import { errorHandledAsync } from "@/shared/context/error-context";
import { LoginHistoryService } from "@/features/user/services/login-history-service";
import { useContext } from "react";
import { ErrorDialogContext } from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";

export const useLoginHistory = () => {
  const { setError } = useContext(ErrorDialogContext);
  const loginHistoryService = new LoginHistoryService();
  const loadingCtx = useContext(LoadingModalContext);

  // ログイン履歴の取得
  const getLoginHistory = async () => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await loginHistoryService.getLoginHistory({});
      return res;
    } catch (error) {
      console.log(error);  // 開発用対応
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getLoginHistory: errorHandledAsync(getLoginHistory, setError),
  };
}